var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 97,
    viewBox: "0 0 76 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.54 3V3C44.9589 3 47.2787 3.96134 48.9886 5.67235L69.9338 26.6315C71.4005 28.0992 72.2244 30.0892 72.2244 32.1641V32.1641M42.54 3H12.7356C7.43643 3 3.14062 7.29582 3.14062 12.595V83.5978C3.14062 88.8969 7.43644 93.1927 12.7356 93.1927H62.6294C67.9286 93.1927 72.2244 88.8969 72.2244 83.5978V32.1641M42.54 3V22.5691C42.54 27.8683 46.8358 32.1641 52.135 32.1641H72.2244",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9447 65.0772L51.5963 64.4086L50.9456 63.739L45.2666 57.8945V55.8209L53.6098 64.4071L45.2666 72.98V70.9045L50.9447 65.0772ZM24.4088 63.739L23.7581 64.4086L24.4097 65.0772L30.0878 70.9045V72.98L21.7446 64.4071L30.0878 55.8209V57.8945L24.4088 63.739ZM34.0864 78.3348L39.8973 50.1926L41.268 50.4804L35.4571 78.6227L34.0864 78.3348Z",
    fill: "black",
    stroke: "#292D32",
    strokeWidth: 1.91899
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/code-icon.19dfade4bc053a0f699f69fbc8faeaec.svg";
export { ForwardRef as ReactComponent };